/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { NavLink } from "react-router-dom"
import { Row, Col, Image, Space, } from "antd";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { TextField, Box, Typography, Button } from "@mui/material";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import clsx from "clsx";
import usePrevious from "../../../../Shared/components/Previous";
import crudActions from "../../../../CRUD/redux/actions";
import { checkViewPermission, checkComponentPermission, checkCRUDPermission } from '../../../../../helpers/utilities';
import { ListTable } from './ListTable.js'
import { useDispatch, useSelector } from "react-redux";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import adminActions from "../../../../YounoteAdmin/SecuritySetup/redux/actions";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import { emptyValidation } from "../../../../../helpers/validation";
import { toast } from 'react-toastify';
import DeleteModal from "../../../../Shared/components/DeleteModal";



const ActivityPrefixManagement = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { featureDetails } = useSelector(state => state.younoteAdminSecuritySetupReducer);
    const { createDetails, createError, createLoader, editDetails, editError, editLoader, getList, getData } = useSelector(state => state.crudReducer);

    const { history } = props;
    const [visible, setVisible] = useState(false);
    const [view, setView] = useState(false);


    const timeoutRef = useRef(null);
    const [iconAnimation, setIconAnimation] = useState(false);
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [form, setForm] = useState({});
    const [error, setError] = useState({});
    const [prefixId, setPrefixId] = useState('');
    const [addMore, setAddMore] = useState(false);
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [search, setSearch] = useState('');
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const prevSearch = usePrevious(search);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const dispatch = useDispatch();
    const [deleteModal, setDeleteModal] = useState(false);
    const [name, setName] = useState('');

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {

    }

    const handleOpen = () => {
        setPrefixId('');
        setVisible(true);
        setError({});
        setForm({})
    };

    const handleClose = () => {
        setPrefixId('');
        setVisible(false);
        setError({});
        setForm({})
    };

    const handleAdd = () => {
        setView(false);
        handleOpen();
    }

    useEffect(() => {
        if (roleManagement !== '' && checkViewPermission('Activity Prefix Management', history, 'Younote Admin')) {
            loadTasks();
        }
    }, [roleManagement]);

    const loadTasks = () => {
        dispatch({
            type: adminActions.FEATURE_DETAILS_START, filter: {
                order: 'id desc'
            }
        });
        dispatchFilter(sortBy, sortOrder);
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const onView = (data, v) => {
        handleOpen();
        setForm({ ...data });
        setPrefixId(data?.id);
        setView(v);
    }

    const handleAddMore = (e) => {
        createPrefix(e);
        setAddMore(true);
    }

    const createPrefix = (e) => {
        e.preventDefault();
        let emptyFeature = emptyValidation('Feature', form?.featureId, 'dropDown');
        let emptyPrefix = emptyValidation('Prefix', form?.prefix);

        if (emptyFeature.isValid && emptyPrefix.isValid) {
            delete form.id; delete form.feature;
            dispatch({
                type: prefixId === '' ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
                url: "activity-prefixes",
                title: "Activity Prefixes",
                id: prefixId,
                details: form
            });
        } else {
            setError({
                'featureId': emptyFeature.errors,
                'prefix': emptyPrefix.errors,
            })
        }
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            dispatchFilter(sortBy, sortOrder);
            handleClose();
            toast.dismiss();
            toast(createDetails);
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let text = createError.error.message;
            setError({
                ...error,
                "featureId": text
            })
        }
    }, [createDetails, createError]);

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            dispatchFilter(sortBy, sortOrder);
            handleClose();
            toast.dismiss();
            toast(editDetails);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let text = editError.error.message;
            setError({
                ...error,
                "featureId": text
            })
        }
    }, [editDetails, editError]);


    useEffect(() => {
        if ((prevSearch !== undefined && search && search?.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData?.length > 0) {
                    setLoadMore(true);
                    if (getData?.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }

        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };

        if (search !== '') {
            or['or'].push({ id: { like: '%' + search.trim() + '%' } });
        }

        filter['and'].push(or);
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'activity-prefixes',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    };

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            if (name === 'featureId') {
                setForm({
                    ...form,
                    [name]: e.id,
                    'feature': e
                });
            } else {
                setForm({
                    ...form,
                    [name]: e
                });
            }
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value
            });
        }
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setPrefixId(data.id);
        setName(data?.feature?.featureName);
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg} title={'Admin'} links={[{ 'label': 'Admin', 'link': '/admin' }, { 'label': 'Activity Prefix Management', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Activity Prefix Management'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Activity Prefix Management', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                fullWidth
                                                onChange={(e) => setSearch(e.target.value)}
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.allCustomerTop)}>
                                    <div className={classes.overlFlowResponsiveDesign}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Activity Prefix Management', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { loadImportExportData('ActivityPrefixManagement'); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Activity Prefix Management', 'create', 'Younote Admin') &&
                                                <NavLink
                                                    to={"#"}
                                                    onClick={() => handleAdd()}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Prefix</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Activity Prefix Management', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <ListTable
                                onView={(data, v) => onView(data, v)}
                                onEdit={(data, v) => onView(data, v)}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                roleManagement={roleManagement}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder} sortBy={sortBy}
                                onDelete={(data) => onDelete(data)}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
                <PrimaryDrawer
                    anchor={'right'}
                    open={visible}
                    variant={'temporary'}
                    handleClose={() => handleClose()}
                    title={`${prefixId ? `${view ? 'View' : 'Edit'}` : 'Add'} Activity Prefix`}
                    className={classes.closeBackGround}
                    component={
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off" onSubmit={(e) => createPrefix(e)}>
                            <div className={classes.customFormFlex}>
                                <Row type="flex" gutter={40}>
                                    <Col span={24}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Module</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.feature?.module?.module || '---'}</Typography>
                                    </Col>
                                    <Col span={24}>
                                        {
                                            view ? <> <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Feature</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.feature?.featureName}</Typography></> :
                                                <AutoCompleteComponent
                                                    name={["Feature ", <span key={"Feature"} className={classes.colorRedRequired}> *</span>]}
                                                    heads={[{ 'key': 'featureName', 'name': 'Name' }, { 'key': 'module', 'name': 'Module', 'relation': 'module' }]}
                                                    details={featureDetails}
                                                    parentValue={customObject(featureDetails, form?.featureId)}
                                                    onChange={(data) => changeHandler(data, 'featureId')}
                                                    parentError={error?.featureId}
                                                    position={"bottom"}
                                                    customClasses={classes.margin20t}
                                                />
                                        }
                                    </Col>
                                    <Col span={24}>
                                        {
                                            view ? <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Prefix</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.prefix}</Typography></> :
                                                <TextField autoComplete='one-time-code'
                                                    label={["Prefix ", <span key={"Feature"} className={classes.colorRedRequired}> *</span>]}
                                                    fullWidth
                                                    value={form?.prefix}
                                                    error={error?.prefix && true}
                                                    helperText={error?.prefix}
                                                    variant={'standard'}
                                                    name={'prefix'}
                                                    className={clsx(classes.margin20t)}
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    InputLabelProps={{
                                                        className: classes.textFieldLableColorCustom,
                                                    }}
                                                    onChange={(e) => changeHandler(e)}
                                                />
                                        }
                                    </Col>
                                </Row>
                            </div>
                            <div className={clsx(classes.btnParent)}>
                                {
                                    !view &&
                                    <Space direction="horizontal" align="center" size={[10, 10]}>
                                        <Button
                                            key="save"
                                            type='submit'
                                            color='primary'
                                            variant="contained"
                                            className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })}>
                                            {
                                                prefixId ? 'Update & Close' : 'Save & Close'
                                            }
                                        </Button>
                                        {
                                            !prefixId && <Button
                                                key="add"
                                                onClick={(e) => handleAddMore(e)}
                                                color='primary'
                                                variant="contained"
                                                className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                            >
                                                Add more
                                            </Button>
                                        }
                                    </Space>
                                }
                            </div>
                        </Box>
                    }
                />
            </div>
            <DeleteModal onClose={(v) => setDeleteModal(v)}
                id={prefixId} loadTasks={() => dispatchFilter(sortBy, sortOrder)} name={name} url={'activity-prefixes'}
                title={'Activity Prefix Management'} visible={deleteModal} />
        </React.Fragment>
    )
}
export default ActivityPrefixManagement